module.exports = __webpack_public_path__ + "img/17_51.e2a25dc0.png";